import React from 'react';

function LocPageFooter({ list1, title }) {
  return (
    <div style={{ paddingLeft: 15, color: 'blue' }}>
      <div>
        <h5>
          Click <a href="/">here</a> for parking policies that apply to all
          locations.
        </h5>
        <h6>
          <h6
            style={{
              textDecoration: 'underline',
            }}
          >
            {title}
            {/* {isClicked ? <Icon.CaretUpFill /> : <Icon.CaretDownFill />} */}
          </h6>
        </h6>
        {/* <div id="questsDiv" style={{ display: 'block' }}>
          {list1}
        </div> */}
      </div>
    </div>
  );
}

export default LocPageFooter;
